<template>
  <div class="page-header navbar navbar-fixed-top">
    <!-- BEGIN LOGO -->
    <div class="page-logo">
      <router-link :to="{ name: 'home' }">
        <img class="logo-default cap" src="/static/front/images/menu-images/b1g1-logo.svg" alt="alt">
      </router-link>

      <div class="menu-toggler sidebar-toggler">
        <!-- DOC: Remove the above "hide" to enable the sidebar toggler button on header -->
      </div>
    </div>
    <a href="javascript:void(0);" class="menu-toggler responsive-toggler" data-toggle="collapse"
      data-target=".navbar-collapse">
    </a>
    <div class="container">
      <!-- BEGIN HEADER INNER -->
      <div class="page-header-inner">
        <div class="page-top">
          <form class="search-form search-form-expanded" action="extra_search.html" method="GET">
            <h2 style="font-size: 26px; font-weight:500;color: #000000; margin-left:0px">Worthy Cause User Panel</h2>
          </form>
          <div class="top-menu">
            <ul class="nav navbar-nav pull-right">
              <li class="dropdown  dropdown-user" v-if="!isAdminLogin">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" @click="showDropDown = !showDropDown">
                  <!-- {{wcName}} -->
                  <span class="profilePic">{{wcName.charAt(0)}}</span>
                  <span class="username username-hide-on-mobile">
                    <span>Welcome,</span> {{
                    wcName.length > 20
                      ? wcName.substr(0, 20) + '...'
                      : wcName
                  }}
                  </span>
                  <span class="caret">
                    <img src="/static/front/images/menu-images/down-arrow.svg" alt="">
                  </span></a>
                <!-- v-if="user.change_type == 1" -->
                <ul class="dropdown-menu" v-if="showDropDown">
                  <!-- <li><a @click="switchToBusiness()"><img src="/static/front/images/drop-down-icon/admin-account.svg" alt="">Business Account</a></li>
                  <li><a @click="switchToAdmin()"><img src="/static/front/images/drop-down-icon/admin-account.svg" alt="">Admin Account</a></li> -->
                  <li>
                    <a @click="logout" class="dropdown-toggle">
                      <span class="username username-hide-on-mobile"><img src="/static/front/images/drop-down-icon/log-out.svg" alt="">Logout </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="dropdown  dropdown-user" v-if="isAdminLogin">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                  <span class="profilePic">{{wcName.charAt(0)}}</span>
                  <span class="username username-hide-on-mobile">
                    <span>Welcome,</span>{{
                    wcName.length > 20
                      ? wcName.substr(0, 20) + '...'
                      : wcName
                  }}
                  </span>
                  <span class="caret">
                    <img src="/static/front/images/menu-images/down-arrow.svg" alt="">
                  </span></a>
                <ul class="dropdown-menu">
                  <!-- <li><a @click="switchToBusiness()">Business Account</a></li> -->
                  <li>
                    <a @click="adminAccount()"><img src="/static/front/images/drop-down-icon/admin-account.svg" alt="">Admin Account</a>
                  </li>
                  <li>
                    <a @click="logout" class="dropdown-toggle">
                      <span class="username username-hide-on-mobile"><img src="/static/front/images/drop-down-icon/log-out.svg" alt="">Logout </span>
                    </a>
                  </li>
                </ul>
              </li>
              <!-- END USER LOGIN DROPDOWN -->
            </ul>
          </div>
          <!-- END TOP NAVIGATION MENU -->
        </div>
        <!-- END PAGE TOP -->
      </div>
      <!-- END HEADER INNER -->
    </div>
  </div>
</template>

<script>
import store from '../../store'
import config from '../../config/app'
import userApi from '../../api/user'

export default {
  mounted () {
    if (this.user && this.user.id) {
      this.getWorthyCauseName(this.user.id)
    }
  },
  methods: {
    getWorthyCauseName (userId) {
      userApi.getWorthyCauseName(userId)
        .then((response) => {
          if (response && response.data) {
            this.wcName = response.data.worthy_cause_name
          } else {
            this.wcName = response.worthy_cause_name
          }
        })
        .catch((error) => {
          console.error('Error fetching worthy cause name:', error)
        })
    },
    switchToAdmin () {
      userApi.changeToAdmin().then((response) => {
        if (response === true) {
          this.$store.dispatch('changeTypeToAdmin')
          this.$router.push('/')
        }
      })
    },
    adminAccount () {
      let data = {
        username: atob(this.form.username),
        password: atob(this.form.password)
      }
      this.$store.dispatch('login', data).then(() => {
        location.href = config.host
      })
    },
    switchToBusiness () {
      userApi.changeToBusiness().then((response) => {
        if (response === true) {
          this.$store.dispatch('changeTypeToBusiness')
          this.$router.push('/')
        }
      })
    },
    logout () {
      this.$store.dispatch('logout')
      window.location.replace(config.host + '/login')
    }
  },
  created () {
    // this.setCurrentMenu(this.$route.name)
    console.log(localStorage.getItem('login_user_type'))
    if (localStorage.getItem('login_user_type') !== '' && localStorage.getItem('login_user_type') === 'admin') {
      console.log('Login')
      this.isAdminLogin = true
    }
  },
  data () {
    return {
      wcName: '',
      user: store.getters.currentUser,
      showDropDown: false,
      isAdminLogin: false,
      form: {
        username: localStorage.getItem('YUJAqQWVZTRRJsvPpKIG') ? localStorage.getItem('YUJAqQWVZTRRJsvPpKIG') : null,
        password: localStorage.getItem('VxdqRJrxxGTZSSwFmmOU') ? localStorage.getItem('VxdqRJrxxGTZSSwFmmOU') : null
      }
    }
  }
}
</script>

<style scoped>
  .dropdown-menu {
    display: block !important;
  }
  .page-header.navbar .page-logo .logo-default.cap {
    filter: inherit;
  }
  .page-header.navbar .page-logo .logo-default.ipad {
    display: none;
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .page-header.navbar .page-logo .logo-default.cap{
      display: none;
    }
    .page-header.navbar .page-logo .logo-default.ipad {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partner/Header.vue